import { columnTypes } from '@qdabra/forms-shared/sharePoint';
import { isNil } from 'ramda';

const {
    SP_TYPE_ATTACHMENTS,
    SP_TYPE_CHOICE,
    SP_TYPE_FULLHTML,
    SP_TYPE_MULTI_CHOICE,
    SP_TYPE_LOOKUP,
    SP_TYPE_LOOKUP_MULTI,
    SP_TYPE_URL,
    SP_TYPE_USER,
    SP_TYPE_USER_MULTI,
} = columnTypes;

const SP_TYPE_COMPATIBLE = 'Compatible';

// TListItem is the type for the list item for the given query type
// getField is: (fieldName: String, listItem: TListItem) -> QueriedListItemField
// getLookupId is: (FieldValue) -> String
// getUrlValue is: (FieldValue) -> { url: String, description: String }

export const valueHandler =
    (getField, getLookupId, getUrlValue) => (item, internalName, type) => {
        const field = getField(internalName, item);

        if (!field) {
            return null;
        }

        const valueArr = field.values || field.value;
        const firstValue = valueArr[0];

        if (isNil(firstValue)) {
            return null;
        }

        switch (type) {
            case SP_TYPE_ATTACHMENTS:
            case SP_TYPE_MULTI_CHOICE:
            case SP_TYPE_USER:
            case SP_TYPE_USER_MULTI:
                return valueArr;
            case SP_TYPE_LOOKUP:
                return getLookupId(firstValue);
            case SP_TYPE_LOOKUP_MULTI:
                return valueArr.map(getLookupId);
            case SP_TYPE_URL:
                return getUrlValue(firstValue);
            case SP_TYPE_FULLHTML:
            case SP_TYPE_COMPATIBLE:
            case SP_TYPE_CHOICE:
            default:
                return firstValue;
        }
    };
